// @flow
import React, {Component} from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import createDebugger from 'debug';
const debug = createDebugger('app:components:Collapsable'); // eslint-disable-line no-unused-vars
import { ThemeType } from 'trustar-2.0/types';
import {Collapse} from 'reactstrap';
import {DefaultTheme} from '../themes';

// TODO PUT IN CONSTANTS
const heightValueCalculator = (heightValue: string = '', multiplier: number) => {
  // Am I proud or ashamed of this
  const [value, units] = heightValue.includes('rem') ?
    heightValue.split('rem').filter(Boolean).concat('rem') :
    heightValue.split('px').filter(Boolean).concat('px');
  return `${multiplier * Number(value)}${units}`;
};

// Style for Main Components (things you may export)
const StyledCollapsable = styled.div`
  display: inline-block;
  height:  ${({theme, numberOfLinesToShow, isOpen}) => heightValueCalculator(theme.FontSizes.P, numberOfLinesToShow)};
`;

const initialValues = {
  isOpen: false,
  numberOfLinesToShow: 5,
  theme: DefaultTheme,
};
  
// Bindings
type CollapsableProps = {
  theme?: ThemeType,
  isOpen?: boolean,
  numberOfLinesToShow?: number,
  doOnToggle?: Function,
  children: any,
};

class Collapsable extends Component {
  props: CollapsableProps;
  static defaultProps = initialValues;
  state = {
    isOpen: this.props.isOpen || initialValues.isOpen
  };
//  ----Template----

  render() {
    return (
      <StyledCollapsable {...this.props}>
        <Collapse isOpen={this.state.isOpen} >
          {this.props.children}
        </Collapse>
      </StyledCollapsable>
    );
  }

// ----Lifecycle Hooks----

// ----Methods----

  toggle = (option: Object) => {
    this.setState({ isOpen: !this.state.isOpen });
    if (this.props.doOnToggle) this.props.doOnToggle();
  };
}

// Logic & Helper Components
const options = [

];

// Connect To State -- Only if this component MUST be connected at declaration. RARE.
const mapStateToProps = (state) => ({
  isOpen: null // Some variable,
});

const dispatchProps = {
  methodOne: ()=>{}, // Some action
};

// export -- Only if this component MUST be connected at declaration. RARE.
// export default connect(mapStateToProps, dispatchProps)(Collapsable);

export {Collapsable};


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Collapsable.js